<!-- 中观概览 -->
<template>
    <div>
        <H3Title :title="boxTitle"></H3Title>

        <div style="display: flex">
            <div style="width: 50%; min-width: 250px">
                <ChartTpl :v-if="ZGOverview.remark" :elementId="'arcgapEle2'" :enableResize="true" :width="'100%'" :height="'240px'" :option="arcgapOption" :originData="arcgapData"></ChartTpl>
            </div>

            <div class="txt" v-if="ZGTodayData.cLDetail">
                <div class="txt-top">
                    <p class="txt-top-title" v-html="fundingSupply"></p>
                    <div :ltip="fundSupplyTip" class="tips"></div>
                    <div class="txt-top-wrap">
                        <div class="txt-top-sideone">
                            <ShowNum :title="'陆股通'" :num="ZGTodayData.fSDetail.lgtLiquidity.realValue"></ShowNum>
                            <p v-html="QFIIAndRQFII"></p>
                            <ShowNum :title="'公募资金'" :num="ZGTodayData.fSDetail.fundIssuanceSize.realValue"></ShowNum>

                            <ShowNum :title="'回购资金'" :num="ZGTodayData.fSDetail.backBuyMoney.realValue"></ShowNum>
                        </div>
                        <div class="txt-top-sidetwo">
                            <ShowNum :title="'打板资金'" :num="ZGTodayData.fSDetail.catchMoney.realValue"></ShowNum>
                            <ShowNum :title="'杠杆资金'" :num="ZGTodayData.fSDetail.financingBalanceMoney.realValue"></ShowNum>
                            <ShowNum :title="'增持资金'" :num="ZGTodayData.fSDetail.increaseMoney.realValue"></ShowNum>
                        </div>
                    </div>
                </div>
                <div class="txt-bottom">
                    <p class="txt-bottom-title" v-html="currencyLiquitidy"></p>
                    <div :ltip="currencyLiquitidyTip" class="tips"></div>
                    <div class="txt-bottom-wrap">
                        <div class="txt-bottom-sideone">
                            <ShowNum :title="'定增金额'" :num="ZGTodayData.cLDetail.fixedIncreaseMoney.realValue"></ShowNum>
                            <ShowNum :title="'配股金额'" :num="ZGTodayData.cLDetail.allotmentMoney.realValue"></ShowNum>
                        </div>
                        <div class="txt-bottom-sidetwo">
                            <ShowNum :title="'减持金额'" :num="ZGTodayData.cLDetail.reductionMoney.realValue"></ShowNum>
                            <ShowNum :title="'IPO金额'" :num="ZGTodayData.cLDetail.IPO.realValue"></ShowNum>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import H3Title from '@/components/H3Title'
import ChartTpl from '@/components/ChartTpl'

let ShowNum = {
    props: {
        title: {
            type: String,
            default: '减持金额',
        },
        num: [String, Number],
    },
    computed: {
        showValue() {
            return this.$util.number.getUnitNumber(this.$util.number.getShowValue(this.num), 2, 0)
        },
        showUnit() {
            return this.showValue === '--' ? '' : this.$util.number.getUnitNumber(this.num, 2, 2)
        },
    },
    template: '<p>{{title}}：<span>{{showValue}}</span>{{showUnit}}</p>',
}

export default {
    name: 'HGOverview',
    components: {
        H3Title,
        ChartTpl,
        ShowNum,
    },
    props: {
        title: {
            type: String,
            default: '中观概览',
        },
        today: {
            type: String,
            default: '',
        },
        ZGTodayData: {
            type: Object,
            default: function () {
                return {}
            },
        },
        ZGOverview: {
            type: Object,
            default: function () {
                return {}
            },
        },
    },
    computed: {
        fundSupplyTip() {
            return (
                '数据更新时间：陆股通-' +
                this.ZGTodayData.fSDetail.lgtLiquidity.date +
                ', QFII-' +
                this.ZGTodayData.fSDetail.QFII.date +
                ', RQFII-' +
                this.ZGTodayData.fSDetail.RQFII.date +
                ', 公募资金-' +
                this.ZGTodayData.fSDetail.fundIssuanceSize.date +
                ', 杠杠资金-' +
                this.ZGTodayData.fSDetail.financingBalanceMoney.date +
                ', 增持资金-' +
                this.ZGTodayData.fSDetail.increaseMoney.date +
                ', 回购资金-' +
                this.ZGTodayData.fSDetail.backBuyMoney.date +
                ', 打板资金-' +
                this.ZGTodayData.fSDetail.catchMoney.date
            )
        },
        currencyLiquitidyTip() {
            return (
                '数据更新时间：定增金额-' +
                this.ZGTodayData.cLDetail.fixedIncreaseMoney.date +
                ', 配股金额-' +
                this.ZGTodayData.cLDetail.allotmentMoney.date +
                ', 减持金额-' +
                this.ZGTodayData.cLDetail.reductionMoney.date +
                ', IPO-' +
                this.ZGTodayData.cLDetail.IPO.date
            )
        },
        boxTitle() {
            return this.title
            // return this.title +' '+ this.today.substr(0, 4) +'-'+this.today.substr(4, 2)+'-'+this.today.substr(6, 2);
        },
        fundingSupply() {
            //资金供给
            let d = this.ZGTodayData.fundingSupply.realValue
            let showStr = this.$util.number.getUnitNumber(this.$util.number.getShowValue(d), 2, 0)
            let unit = this.$util.number.getUnitNumber(d, 2, 2)

            return '资金供给&nbsp;&nbsp;<span>' + showStr + '</span>' + unit + ' :'
        },
        currencyLiquitidy() {
            //资金需求
            let d = this.ZGTodayData.currencyLiquidity.realValue
            let showStr = this.$util.number.getUnitNumber(this.$util.number.getShowValue(d), 2, 0)
            let unit = this.$util.number.getUnitNumber(d, 2, 2)

            return '资金需求&nbsp;&nbsp;<span>' + showStr + '</span>' + unit + ' :'
        },
        QFIIAndRQFII() {
            let QFII = this.$util.number.getUnitNumber(this.$util.number.getShowValue(this.ZGTodayData.fSDetail.QFII.realValue), 2, 0)
            let QFIIUnit = this.$util.number.getUnitNumber(this.ZGTodayData.fSDetail.QFII.realValue, 2, 2)
            let RQFII = this.$util.number.getUnitNumber(this.$util.number.getShowValue(this.ZGTodayData.fSDetail.RQFII.realValue), 2, 0)
            let RQFIIUnit = this.$util.number.getUnitNumber(this.ZGTodayData.fSDetail.RQFII.realValue, 2, 2)

            return `<span style="color:#a6a9ae;">QFII：</span>
      <span>$${QFII}</span>
      <span style="color:#a6a9ae;">${QFIIUnit}</span>
      <span style="color:#a6a9ae;margin-left:8px;">RQFII：</span>
      <span>${RQFII}</span>
      <span style="color:#a6a9ae;">${RQFIIUnit}</span>`
        },
    },
    data() {
        return {
            arcgapOption: {},
            arcgapData: [],
        }
    },
    mounted() {
        LTip.width = 200
        LTip.pos = 'right'
        LTip.theme = 'black'
        LTip.reBind()
    },
    updated() {
        LTip.reBind()
    },
    watch: {
        ZGOverview: {
            handler(newvalue, oldvalue) {
                this.initArcgap()
            },
        },
    },
    methods: {
        initArcgap() {
            let data = (this.ZGOverview.remark.percentile * 100).toFixed(0)
            this.arcgapOption = this.$chartConfigs.zgArc()
            this.arcgapOption.data[0] = {
                originData: {
                    value: data,
                },
            }
            this.arcgapData = this.arcgapOption.data
        },
    },
}
</script>

<style lang="scss" scoped>
.txt {
    font-size: 13px;
    min-width: 332px;
    position: relative;
    // top: 20px;
    margin-top: 20px;
    flex: 1;
    margin-left: 10px;
    p {
        line-height: 22px;
        display: inline-block;
    }
    &-top {
        margin-bottom: 20px;
        &-title {
            font-size: 15px;
        }
        &-wrap {
            display: flex;
        }
        &-sideone {
            margin-right: 5%;
        }
    }
    &-bottom {
        &-title {
            font-size: 15px;
        }
        &-wrap {
            display: flex;
        }
        &-sideone {
            margin-right: 5%;
        }
    }
}

.tips {
    position: relative;
    background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/tips.png') no-repeat;
    margin-left: 10px;
    display: inline-block;
    width: 28px;
    height: 22px;
    line-height: 22px;
    vertical-align: middle;
}
.mark {
    position: relative;
    display: inline-block;
    background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/mark.png') no-repeat;
    vertical-align: middle;
    width: 17px;
    height: 11px;
}
.tab.active {
    background: #3b3c41;
    color: #fff;
    cursor: default;
}

.txt ::v-deep span {
    color: #fd4332;
}
</style>
